import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../../constants/appRoutes';
import logo from '../../assets/icons/logo.svg';
import '../../App.scss';
import { LanguageDropdown } from '../LanguageDropdown';

import styles from './styles.module.scss';

const Header = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <Link to={APP_ROUTES.MAIN_PAGE} className={styles.headerLink}>
        <img className={styles.logo} src={logo} alt="HeeBenor logo" />
        <p>HeeBenor</p>
      </Link>
      <div className={styles.rColWrapper}>
        <Link
          to={APP_ROUTES.FAQ}
          className={`${
            location.pathname === APP_ROUTES.FAQ ? styles.faqActive : ''
          }`}
        >
          {t('FAQ')}
        </Link>
        <LanguageDropdown />
      </div>
    </div>
  );
};

export default Header;
